import { addressForHash as _addressForKey } from './addressSelectors';
import { replaceAddressWithHashSaga as _replaceAddressWithHashSaga } from './addressSagas';

import {
    FIRST_NAME_MAX_LENGTH as _FIRST_NAME_MAX_LENGTH,
    LAST_NAME_MAX_LENGTH as _LAST_NAME_MAX_LENGTH,
    RECIPIENT_NAME_MAX_LENGTH as _RECIPIENT_NAME_MAX_LENGTH,
    CARD_NAME_MAX_LENGTH as _CARD_NAME_MAX_LENGTH,
    ADDRESS_FULLNAME as _ADDRESS_FULLNAME,
    ADDRESS_FIRSTNAME as _ADDRESS_FIRSTNAME,
    ADDRESS_LASTNAME as _ADDRESS_LASTNAME,
    ADDRESS_STREET1 as _ADDRESS_STREET1,
    ADDRESS_STREET2 as _ADDRESS_STREET2,
    ADDRESS_CITY as _ADDRESS_CITY,
    ADDRESS_STATE as _ADDRESS_STATE,
    ADDRESS_POSTCODE as _ADDRESS_POSTCODE,
    ADDRESS_COUNTRY as _ADDRESS_COUNTRY,
    ADDRESS_EMAIL as _ADDRESS_EMAIL,
    ADDRESS_PHONE as _ADDRESS_PHONE,
    addressFieldNames as _addressFieldNames,
    replaceAddressWithHash as _replaceAddressWithHash
} from './addressUtils';

export const FIRST_NAME_MAX_LENGTH = _FIRST_NAME_MAX_LENGTH;
export const LAST_NAME_MAX_LENGTH = _LAST_NAME_MAX_LENGTH;
export const FULL_NAME_MAX_LENGTH = _RECIPIENT_NAME_MAX_LENGTH;
export const CARD_NAME_MAX_LENGTH = _CARD_NAME_MAX_LENGTH;
export const ADDRESS_FULLNAME = _ADDRESS_FULLNAME;
export const ADDRESS_FIRSTNAME = _ADDRESS_FIRSTNAME;
export const ADDRESS_LASTNAME = _ADDRESS_LASTNAME;
export const ADDRESS_STREET1 = _ADDRESS_STREET1;
export const ADDRESS_STREET2 = _ADDRESS_STREET2;
export const ADDRESS_CITY = _ADDRESS_CITY;
export const ADDRESS_STATE = _ADDRESS_STATE;
export const ADDRESS_POSTCODE = _ADDRESS_POSTCODE;
export const ADDRESS_COUNTRY = _ADDRESS_COUNTRY;
export const ADDRESS_EMAIL = _ADDRESS_EMAIL;
export const ADDRESS_PHONE = _ADDRESS_PHONE;
export const addressFieldNames = _addressFieldNames;

export const addressForKey = _addressForKey;
export const replaceAddressWithHash = _replaceAddressWithHash;
export const replaceAddressWithHashSaga = _replaceAddressWithHashSaga;
